import { getConfigurationValue } from '../utils/general';
import { getUserId, getSvocId } from '../utils/customer';
var userId = getUserId();
var svocId = getSvocId();
export var B2B_ACCOUNT_PATH = '/b2b/user/account';
export var B2B_ACCOUNT_VIEW_PATH = '/b2b/account/view';
export var IMAGES_ASSETS_URL = 'https://assets.thdstatic.com/images/v1';
export var B2B_ACCOUNT_PATH_WITH_USER_ID = "".concat(B2B_ACCOUNT_PATH, "/").concat(userId);
export var B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/customer/").concat(svocId);
export var B2B_POJOB_RETRIEVE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/poJob/retrieve");
export var B2B_POJOB_CREATE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/poJob/create");
export var B2B_POJOB_DELETE_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/poJob/delete");
export var B2B_POJOB_SEARCH_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/poJob/searchPoJob");
export var B2B_PROALLOWANCE_V2_PATH = "".concat(B2B_ACCOUNT_PATH, "/ra/pos/v2/").concat(svocId);
export var B2B_PROALLOWANCE_V1_PATH = "".concat(B2B_ACCOUNT_PATH, "/ra/pos/v1/").concat(svocId);
export var B2B_PROALLOWANCE_RETRIEVE_PAA_CARDS_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/payment/retrieve?isProAllowance=true&typecd=cc&pn=1&ps=30");
// fetch one card only
export var B2B_PROALLOWANCE_RETRIEVE_ALL_PMT_CARDS_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID_SVOC_ID, "/payment/retrieve?typecd=cc&ps=1&pn=1&sb=lastedited&asc=false");
export var B2B_PROALLOWANCE_CREATE_WITH_AUTH_PATH = "".concat(B2B_ACCOUNT_PATH, "/ra/pos/v2/").concat(svocId, "/createProAllowanceWithAuth");
var showNewPurchaseHistoryPage = getConfigurationValue('ENABLE_NEW_PURCHASE_HISTORY_PAGE') === '1';
// Uses fs flag to render purchase history experience if active
export var B2B_PURCHASE_HISTORY_PAGE = showNewPurchaseHistoryPage
    ? "/myaccount/purchase-history"
    : "".concat(B2B_ACCOUNT_VIEW_PATH, "/order/summary");
export var getB2BViewPurchasesPath = function (requestSearchCriteria) {
    var params = {
        requestSearchSelectorValue: 'POJobName',
        requestSearchCriteria: requestSearchCriteria,
    };
    var searchParams = new URLSearchParams(params);
    return "".concat(B2B_PURCHASE_HISTORY_PAGE, "?").concat(searchParams.toString());
};
export var B2B_PREFERENCES_PATH = "".concat(B2B_ACCOUNT_PATH_WITH_USER_ID, "/profile/businessPreferences");
export var PROXTRA_PROGRAM_DETAILS = "/myaccount/proxtraprogramdetails";
export var MANAGE_USERS_URL = '/myaccount/addmanageusers';
export var PAYMENTS_URL = '/myaccount/payments';
export var ADD_CREDIT_CARD_MODAL = '/myaccount/payments/addcreditcard';
export var proAllowanceConfirmationImageUrl = 'https://assets.thdstatic.com/images/v1/scanner-virtual-id.svg';
export var MANAGE_PRO_ALLOWANCE_PATH = '/myaccount/proallowance';
export var MANAGE_ASSIGN_PRO_ALLOWANCE_PATH = '/myaccount/proallowance/assign';
